export default [
    { value: 'JurosProRata', text: 'Juros Pró-rata' },
    { value: 'JurosCompostos', text: 'Juros Compostos' }
]